import { useEffect, useState } from "react";

import { UploadCloudFill } from "@hl/base-components/lib/assets/icons.generated";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { Anchor, Group, Stack, Text } from "@mantine/core";
import { isEmpty } from "lodash";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "~/../../shared-features/lib/features/auth/hooks";

import {
  TokenMetadataAttribute,
  _CollectionType,
} from "apollo/graphql.generated";
import { EditMetadataModal } from "~/features/tokens/sections/ManageToken/modals/EditMetadataModal/index";
import { SetBaseUriModal } from "~/features/tokens/sections/ManageToken/modals/SetBaseUri";
import { ViewMetadataModal } from "~/features/tokens/sections/ManageToken/modals/ViewMetadataModal/index";
import { PropertyBox } from "~/features/tokens/sections/ManageToken/properties/PropertyBox";
import { GetManageTokenCollectionQuery } from "~/features/tokens/sections/ManageToken/queries.graphql.generated";

export const MetadataProperty = ({
  fileSize,
  seriesTokens,
  collectionMediaUrl,
  collectionAnimationUrl,
  name,
  description,
  isAuction,
  attributes,
  showSetBaseUriBtn,
  mirroredBaseUri,
  collectionId,
  contractAddress,
  chainId,
  collectionType,
  collectionSize,
  metadataIsDecentralized,
  reveal,
}: {
  fileSize?: string;
  seriesTokens?: GetManageTokenCollectionQuery["getCollection"]["seriesTokens"];
  collectionMediaUrl: string;
  collectionAnimationUrl: string | null;
  name: string;
  description: string;
  isAuction: boolean;
  attributes?: TokenMetadataAttribute[] | null;
  showSetBaseUriBtn: boolean;
  mirroredBaseUri: string;
  collectionId: string;
  collectionType: _CollectionType;
  collectionSize: number;
  contractAddress: string;
  chainId: number;
  metadataIsDecentralized: boolean;
  reveal: boolean;
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [showSetBaseUriModal, setShowSetBaseUriModal] =
    useState<boolean>(false);

  const enableSeriesMetadataUpdates = useFeatureFlags(
    FEATURE_FLAGS.ENABLE_SERIES_METADATA_UPDATES
  );
  showSetBaseUriBtn; // use

  useEffect(() => {
    if (showSetBaseUriModal) {
      setShowModal(false);
    }
  }, [showSetBaseUriModal]);

  useEffect(() => {
    if (showModal) {
      setShowSetBaseUriModal(false);
    }
  }, [showModal]);

  // TODO: https://linear.app/highlight-xyz/issue/ENG-5161/[collections-transactions]-return-bool-is-there-an-update-metadata-tx
  const updateInProgress = false;
  return (
    <>
      <PropertyBox
        label="Metadata"
        value={
          <>
            <Group noWrap>
              <UploadCloudFill />
              <Stack spacing={0}>
                <Text size="sm">Uploaded to Arweave</Text>
                {fileSize && (
                  <Text size="xs" color={TEXT_COLOR.SECONDARY}>
                    {fileSize}
                  </Text>
                )}
              </Stack>
            </Group>
            {collectionType !== _CollectionType.GenerativeSeries && (
              <Anchor underline={false}>
                <Group position="right" sx={{ rowGap: 0 }}>
                  <Text size="sm" fw={500} onClick={() => setShowModal(true)}>
                    View
                  </Text>
                  {(!enableSeriesMetadataUpdates &&
                    collectionType === _CollectionType.Series) ||
                  reveal ? (
                    <></>
                  ) : (
                    <Text
                      size="sm"
                      fw={500}
                      onClick={() => {
                        if (!updateInProgress) {
                          setShowEditModal(true);
                        }
                      }}
                    >
                      {!updateInProgress ? "Edit" : ""}
                    </Text>
                  )}
                  {/*showSetBaseUriBtn && (
                    <Text
                      size="sm"
                      fw={500}
                      onClick={() => setShowSetBaseUriModal(true)}
                    >
                      Decentralize on contract
                    </Text>
                  )*/}
                </Group>
              </Anchor>
            )}
          </>
        }
      />
      {showModal && (
        <ViewMetadataModal
          seriesTokens={seriesTokens}
          attributes={attributes ?? []}
          onClose={() => setShowModal(false)}
          isAuction={isAuction}
          collectionType={collectionType}
          mediaUrl={collectionAnimationUrl ?? collectionMediaUrl}
          coverImageUrl={
            !isEmpty(collectionAnimationUrl) ? collectionMediaUrl : ""
          }
          name={name}
          description={description}
        />
      )}
      {showEditModal && (
        <EditMetadataModal
          collectionId={collectionId}
          collectionType={collectionType}
          currentMediaUrl={collectionMediaUrl}
          currentAnimationUrl={collectionAnimationUrl || ""}
          currentName={name}
          currentDescription={description}
          attributes={attributes ?? []}
          onClose={() => setShowEditModal(false)}
          chainId={chainId}
          metadataIsDecentralized={metadataIsDecentralized}
          reveal={reveal}
          collectionSize={collectionSize}
        />
      )}
      {showSetBaseUriModal && (
        <SetBaseUriModal
          isOpened={showSetBaseUriModal}
          collectionId={collectionId}
          address={contractAddress}
          collectionType={collectionType}
          mirroredBaseUri={mirroredBaseUri}
          onClose={() => setShowSetBaseUriModal(false)}
          chainId={chainId}
        />
      )}
    </>
  );
};
